<template>
  <div class="p-6 md:p-0" style="height: 80vh">
    <!-- main row choose between yearly and monthly plans -->
    <div
      class="flex md:flex-row flex-col mb-6 items-center justify-between md:justify-start"
    >
      <r-button
        id="monthly-plan-button"
        class="w-full md:w-auto md:mr-2"
        :text="planLength === 'yearly'"
        @click="planLength = 'monthly'"
      >
        {{ $t("payments.monthly") }}
      </r-button>

      <r-button
        id="yearly-plan-button"
        class="w-full md:w-auto md:ml-2"
        :text="planLength === 'monthly'"
        @click="planLength = 'yearly'"
      >
        {{ $t("payments.yearly") }}
      </r-button>
    </div>

    <!-- second row render plans -->
    <div class="flex flex-col md:flex-row justify-between">
      <!-- left side less than 100 users -->
      <div
        class="flex flex-col items-center bg-white rounded w-full md:mr-2 p-4 mb-6 md:mb-0"
      >
        <!-- title -->
        <div class="font-bold">
          {{ $t("payments.small") }}
        </div>

        <!-- description -->
        <div
          v-html="$t('payments.smallDescription')"
          class="text-center my-8"
        />

        <!-- select plan -->
        <r-button
          id="create-subscription-button"
          @click="createSubscription"
          :loading="loading"
        >
          {{ planPrice }}$/{{ $t(`payments.planLayout_${planLength}`) }}
        </r-button>
      </div>

      <!-- right side more than 100 users -->
      <div
        class="flex flex-col items-center bg-white rounded w-full md:ml-2 p-4"
      >
        <!-- title -->
        <div class="font-bold">
          {{ $t("payments.enterprise") }}
        </div>

        <!-- description -->
        <div
          v-html="$t('payments.enterpriseDescription')"
          class="text-center my-8"
        />

        <!-- contact us -->
        <r-button id="redirect-connect-us-button" @click="redirectToContactUs">
          {{ $t("payments.contactUs") }}
        </r-button>
      </div>
    </div>
    <!-- Dialogs -->
    <rele-payment-alert-dialog v-model="paymentAlertDialog.open" />
  </div>
</template>

<script>
import moment from "moment"
import { mapGetters } from "vuex"
import paymentsAPI from "@/api/payments"
import { loadStripe } from "@stripe/stripe-js"

/**
 * Define the no-subscription payment page
 */
export default {
  // component data
  data() {
    return {
      // plan len
      planLength: "monthly",

      // loading button
      loading: false,

      // payments dialog
      paymentAlertDialog: {
        open: false
      }
    }
  },

  // external props
  props: {
    apiKey: {
      type: String,
      required: true
    }
  },

  // mounted hook
  mounted() {
    // open popup if needed
    if (this.isOpenPaymentAlert) {
      this.$set(this.paymentAlertDialog, "open", true)
    }
  },

  // calculated props
  computed: {
    // spread store values
    ...mapGetters({
      jwt: "auth/getIdToken",
      selectedOrg: "auth/getSelectedOrg",
      org: "orgs/getDoc"
    }),

    /**
     * Calculate the plan price
     */
    planPrice() {
      if (this.planLength === "monthly") {
        return "6"
      } else {
        return "5"
      }
    },

    /**
     * Determine if trial is over
     */
    isTrialOver() {
      if (this.org && this.org.create_timestamp) {
        const createDate = moment(this.org.create_timestamp.toDate())
        createDate.add(this.org.trail_days, "days")
        return moment().isAfter(createDate)
      }

      return false
    },

    /**
     * Determine if redirect to payment page needed
     */
    isOpenPaymentAlert() {
      // pull is showing popup
      const isNotShowingAgain = localStorage.getItem("payment-dialog")

      return (
        this.isTrialOver && !isNotShowingAgain && !(this.org || {}).subscription
      )
    }
  },

  // handle notification
  notifications: {
    notifyError: {
      type: "error"
    }
  },

  // component functions
  methods: {
    /**
     * Create the subscription
     */
    async createSubscription() {
      this.loading = true

      try {
        // get the subscription type
        const priceType = this.planLength === "monthly" ? "month" : "year"

        // create the subscription
        console.log("token", this.jwt)
        const session = await paymentsAPI.subscriptions(this.jwt).create({
          successUrl: `${location.origin}/payments/success`,
          cancelUrl: `${location.origin}/payments/fail`,
          priceType
        })

        console.log("session", session)

        // redirect to checkout
        const stripe = await loadStripe(this.apiKey)
        stripe.redirectToCheckout({ sessionId: session.id })
      } catch (e) {
        console.error(e)
        this.notifyError({
          title: this.$t("errors.unableToCreatePaymentSubscription"),
          message: e.message
        })
      }

      this.loading = false
    },

    /**
     * Redirect to contact us on the website
     */
    redirectToContactUs() {
      const win = window.open("https://rele.ai/contact/", "_blank")
      win.focus()
    }
  }
}
</script>
